import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'app/config'
import axios from 'axios';

import DeliveryDetailsMap from "./DeliveryDetailsMap";
import DeliveryDetailsRatingForm from "./DeliveryDetailsRatingForm";
import DeliveryDetailsIssueForm from "./DeliveryDetailsIssueForm";
import DeliveryDetailsThumbs from "./DeliveryDetailsThumbs";
import DeliveryDetailsProgress from "./DeliveryDetailsProgress";
import DeliveryDetailsTimelineItem from './DeliveryDetailsTimelineItem';
import { translate } from '../../../common/translations';
import DeliveryDetailsAddress from './DeliveryDetailsAddress';

class CustomerSearchForm extends Component {

	constructor(props) {
		super(props);
		this.state = {
			extraCare: null
		}
	}

	componentDidMount() {
		const props = this.props;
		const delivery = this.props.delivery;
		const deliveryConfig = this.props.deliveryConfig;

		if (delivery && delivery.clientId === 182 && deliveryConfig.extraCareEnabled) {
			const city = delivery.city;
			const postcode = delivery.postcode;
			const date = delivery.deliveryDateDt;
			const formattedDate = date

			axios.get(`https://api.homedelivery.com.au/api/vics-meat?suburb=${city}&postcode=${postcode}&date=${formattedDate}`)
				.then(response => {
					if (response.data.includes('Unknown')) {
						this.state({
							extraCare: ''
						})
					} else {
						this.setState({
							extraCare: response.data
						})
					}
				})
				.catch(error => {
					console.debug(error);
				});
		}
	}

	render() {
		const { extraCare } = this.state;
		const props = this.props;
		const delivery = this.props.delivery;
		const deliveryConfig = this.props.deliveryConfig;
		const { boxes, scanLog } = delivery;
		const styles = deliveryConfig.clientStyles;

		// Filter scanLog to remove duplicate status pick ups eg 2x 'pick up' scans
		// This is replicated across different delivery states so move it to a custom hook when you get a chance
		const scanLogFiltered = Array.from(new Set(scanLog?.map(a => a.status)))
			.map(status => {
				return scanLog.find(a => a.status === status)
			})

		console.debug('Delivery Status: Delivered');

		if (delivery.deliveryNotes) {
			delivery.deliveryNotes = delivery.deliveryNotes.trim() == '' ? '' : delivery.deliveryNotes;
		} else {
			delivery.deliveryNotes = '';
		}

		delivery.driversNotes = delivery.driversNotes == '' ? translate(props.lang, 'No driver note') : delivery.driversNotes;
		let deliveryImages = [];

		if (delivery.photo1 !== undefined && delivery.photo1 !== null && delivery.photo1 !== '') {
			deliveryImages.push(
				<div key="photo1" className="col-6">
					<img className="img-fluid" src={config.apiBase + '/api/DeliveryImage/' + delivery.photo1} />
				</div>);
		}

		if (delivery.photo2 !== undefined && delivery.photo2 !== null && delivery.photo2 !== '') {
			deliveryImages.push(
				<div key="photo2" className="col-6">
					<img className="img-fluid" src={config.apiBase + '/api/DeliveryImage/' + delivery.photo2} />
				</div>);
		}

		if (delivery.photo3 !== undefined && delivery.photo3 !== null && delivery.photo3 !== '') {
			deliveryImages.push(
				<div key="photo3" className="col-6">
					<img className="img-fluid" src={config.apiBase + '/api/DeliveryImage/' + delivery.photo3} />
				</div>);
		}

		if (delivery.photo4 !== undefined && delivery.photo4 !== null && delivery.photo4 !== '') {
			deliveryImages.push(
				<div key="photo4" className="col-6">
					<img className="img-fluid" src={config.apiBase + '/api/DeliveryImage/' + delivery.photo4} />
				</div>);
		}

		if (delivery.photo5 !== undefined && delivery.photo5 !== null && delivery.photo5 !== '') {
			deliveryImages.push(
				<div key="photo5" className="col-6">
					<img className="img-fluid" src={config.apiBase + '/api/DeliveryImage/' + delivery.photo5} />
				</div>);
		}

		const DeliveryImageContent = deliveryImages.length === 0 ? null : (
			<div key="deliveryImagesTitle" className="row division white-bg">
				<div className="col-12 text-center">
					<h3>{translate(props.lang, 'Delivery Photos')}</h3>
				</div>

				<div key="deliveryImagesPhotos" className="row col-12 ml-0 mr-0">
					{deliveryImages}
				</div>
			</div>
		);

		const DeliveryNotesContent = (deliveryConfig.showDeliveryNotes) ? (
			<div className="row division white-bg">
				<div className="col-md-6">
					<h3>{translate(props.lang, 'Delivery Notes')}</h3>
					<p>
						{delivery.deliveryNotes}
					</p>
				</div>

				<div className="col-md-6">
					<h3>{translate(props.lang, "Driver's Notes")}</h3>
					<p>
						{delivery.driversNotes}
					</p>
				</div>
			</div>
		) : null;

		const Rating = (deliveryConfig.showSubmitIssue && (delivery.deliveryStatus === 'Completed' || delivery.deliveryStatus === 'Delivered') || delivery.deliveredDt) ? [
			<DeliveryDetailsThumbs lang={props.lang} key="rating-form" delivery={delivery} deliveryConfig={deliveryConfig} />
		] : null;

		const data = {
			displayMessage: delivery.deliveryStatus,
			deliveryDate: delivery.deliveryDate,
			deliveryTime: delivery.deliveryTime,
			status: 'van',
		}

		return (
			<div className="deliveryDetails row">
				<div className="col-12">
					<div className="row division white-bg">
						<div className="col-12 text-center">
							<h3>{translate(props.lang, 'Time Delivered')}</h3>
							<p style={styles.textHighlight} className="deliveryTime mb-0">{delivery.deliveryTime}</p>
							<p style={styles.textHighlight} className="deliveryDate">{delivery.deliveryDate}</p>
						</div>
					</div>

					{deliveryConfig.showDeliveryDetails ?
						<>
							<DeliveryDetailsMap lang={props.lang}
								latitude={delivery.latitude}
								longitude={delivery.longitude}
								deliveryConfig={deliveryConfig}
							/>

							{boxes &&
								<DeliveryDetailsAddress lang={props.lang}
									delivery={delivery}
									styles={styles}
									boxes={boxes}
								/>
							}

							{extraCare &&
								<p className="flex-d text-center mt-4 font-weight-bold" style={{ color: 'black' }}>{extraCare}</p>
							}

							{/* Reminder: Remove this when driver app is stood up */}
							<div className="row division white-bg timeline-container">
								<DeliveryDetailsTimelineItem lang={props.lang}
									key={data.scannedDt}
									styles={styles}
									data={data}
									delivered
								/>

								{scanLogFiltered && scanLogFiltered.length > 0 &&
									scanLogFiltered.map((data) =>
										<DeliveryDetailsTimelineItem lang={props.lang}
											key={data.scannedDt}
											styles={styles}
											data={data}
											deliveryStatus={delivery.deliveryStatus}
										/>
									)
								}
							</div>
						</>
						: null
					}

					{DeliveryNotesContent}
					{DeliveryImageContent}
					{Rating}

					<p className="flex-d text-center mt-4">&nbsp;</p>
				</div>
			</div>
		);
	}
}

CustomerSearchForm.contextTypes = {

};

const mapStateToProps = (state) => ({
	isEditingContact: state.isEditingContact
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerSearchForm);
